export const CMS_PREFIX_LIST = {
  shared: "shared",
  care: "care/text/akina-care",
  session: "care/text/akina-session",
  portal: {
    treatments: "portal/treatments",
    navigation: "portal/navigation/portal-navigation",
    home: "portal/home",
    myTasks: "portal/my-tasks",
    sessionReview: "portal/session-review",
    entryScreen: "portal/entry-screens",
    institution: "portal/roles/institution-profile-page",
    patientManagement: "portal/patient-management",
    roles: "portal/roles",
    settings: "portal/settings",
    useOnDesktopOrMobileAppDialog: "portal/useOnDesktopOrMobileAppDialog",
  },
};
